import { useEffect } from 'react';
import { states } from '@/constants/lifecycle';

const useFetchCollection = (fetch, category, code, readStatus, isNew) => {
  useEffect(() => {
    if (readStatus === states.NONE) {
      fetch(category, code, isNew);
    }
  }, []);
};

export default {
  useFetchCollection,
};
